import styled from "@emotion/styled"

export const $ImageInline = styled("span")`
  display: inline;
`
